import React from 'react';
import { Typography } from 'antd';
import NotificationsTable from '../components/notifications/NotificationsTable';

const { Title } = Typography;

const Notifications = () => {
  return (
    <div style={{ padding: 24 }}>
      <Title level={2} style={{ marginBottom: 24 }}>
        Notifications des Articles
      </Title>
      <NotificationsTable />
    </div>
  );
};

export default Notifications;
